// extracted by mini-css-extract-plugin
export default {"wrapper":"form_wrapper__bfhm5","hidden":"form_hidden__jQzdW"};